export const CUSTOMER_SESSION_API = '/api/stripe/customer-sessions';

export const CUSTOMER_PORTAL_SESSION_API = '/api/stripe/customer-portal-sessions';

export const SUBSCRIPTIONS_API = '/api/subscriptions';

export const TRIAL_DISCOUNT_API = '/api/stripe/trial-discount';
